import { AnswerInfo, ResponseInfo } from "../../models/models";
import { getEmptyForm } from './Form';
import { getEmptyResponse } from './Response';

export function getEmptyResponseInfo(form_id:number): ResponseInfo
{
		return {
			response: getEmptyResponse(form_id),
			form: getEmptyForm(),
			answers: [] as AnswerInfo[],
			user:null,
		}
}
